import { render, staticRenderFns } from "./vCheckbox.vue?vue&type=template&id=79a040d4&"
import script from "./vCheckbox.vue?vue&type=script&lang=js&"
export * from "./vCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./vCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports